module.exports = __webpack_public_path__ + "media/images/pages/careers-support/benchmark_5-fc5e350cc92be430d533cab2565434ea.svg";